var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('com-logo'),_c('div',{staticClass:"head-divide"}),_c('com-search'),(!_vm.$isMobile)?_c('com-voting'):_vm._e(),(!_vm.$isMobile)?_c('com-access'):_vm._e(),_c('com-patreon'),_c('com-inbox'),(_vm.loggedin)?_c('com-groups'):_vm._e(),_c('com-account')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }